/* eslint-disable no-use-before-define */
import { publish } from '../twd'
import { getBrand, getSessionId, getUserId, getEnvironment } from '../get-config';
import { processors } from './processors'
import { parseStringBlocks, parseJson } from '../parse';

export default (cfg, eventCodes = ['user.logout']) => {

    let url = cfg.notifier_url
    if (!url) return

    let sid = getSessionId()
    if (!sid) return

    let subscriptions = eventCodes.map((e) => sid + '.' + e).join()
    subscribeToAtmosphere(cfg.notifier_url, subscriptions)

    // let brand = getBrand()
    // setInterval(() => {
    //     ajax({
    //         url: cfg.bw_service_host + '/' + brand + '/servlet/rtresult/longpoll.htm',
    //         method:'POST',
    //         body: JSON.stringify({ brand, sessionid:sid }),
    //         ignoreResponse: true
    //     })
    // }, 120000)

}

const subscribeToAtmosphere = (url, subscriptions) => {
    if (!url) return

    let req = Object.assign(new global.atmosphere.AtmosphereRequest(), {
        url,
        contentType: 'application/json',
        logLevel: 'error',
        withCredentials: true,
        transport: 'websocket',
        trackMessagelength: true,
        reconnectInterval: 180000,
        fallbackTransport: 'long-polling',

        headers: {
            brand: getBrand(),
            environment: getEnvironment(),
            user: getUserId()
        },

        onOpen: (r) => {
            r = r || {}
            if (r.status!==200) return
            socket.push({ data:subscriptions })
        },
        onReopen: (r) => {
            socket.push({ data:subscriptions })
        },

        onError: (r) => {},
        onMessage: (r) => {
            r = r || {}
            if (r.status!==200) return

            parseStringBlocks(r.responseBody).forEach(a => {
                try {
                    let msg = typeof(a)==='object' ? a : parseJson(a)
                    if (!msg) return

                    if (msg.value==='READY' && msg.tag==='READY') {
                        socket.push({ data:subscriptions })
                        return
                    }

                    processAtmosphereMessage(msg)
                } catch(x) {}
            })
        },

        onReconnect: () => {
            publish('atmosphere_reconnected', { ts: Date.now() })
        },
        onTransportFailure: (err, req) => {
            req.fallbackTransport = 'long-polling'
        }
    })

    let socket = global.atmosphere.subscribe(req)
    return socket
}


export const processAtmosphereMessage = ({tag, key, value}) => {
    if (!key && tag) {
        key='Order'
    }

    if (!key) return

    let p = processors[key]
    if (!p) return

    let v = typeof(value) === 'object' ? value : JSON.parse(value)
    p(v)
}



// WEBPACK FOOTER //
// ./src/twd/atmosphere/atmosphere.js